import React, { useEffect } from 'react';
import { useScrollLockManager } from '../ScrollLock/useScrollLockManager.js';
export const Backdrop = ({ onClick }) => {
    const scrollLockManager = useScrollLockManager();
    useEffect(() => {
        scrollLockManager.registerScrollLock();
        return () => {
            scrollLockManager.unregisterScrollLock();
        };
    }, [scrollLockManager]);
    return (React.createElement("div", { className: "fixed inset-0 bg-background-backdrop", onClick: onClick, onTouchStart: onClick }));
};
//# sourceMappingURL=Backdrop.js.map